import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import R from 'ramda';
import classNames from 'classnames';
import styles from './text-input.css';

const { fieldset, label, textarea, input } = hh(h);

const TextInput = ({
    labelText = '',
    id = false,
    size = 'medium',
    ...props
}) => {
    const uid = `${id || labelText}${R.toString(v4())}`;
    const labelElement = label({className: styles.label, htmlFor: uid}, labelText);
    const inputClasses = classNames(styles.input, R.prop(`${size}Size`, styles));

    if (R.equals(props.type, 'textarea')) {
        return (
            fieldset({className: classNames(styles.container, styles.fieldset)}, [
                labelElement,
                textarea({className: inputClasses, id: uid, ...props})])
        );
    }

    return (
        fieldset({className: classNames(styles.container, styles.fieldset)},
                 R.reject(
                     R.isNil,
                     [
                         R.isEmpty(labelText) ? null : labelElement,
                         input({className: inputClasses, id: uid, ...props})
                     ]))
    );
};

TextInput.propTypes = {
    labelText: PropTypes.string,
    id: PropTypes.string,
    size: PropTypes.oneOf(['medium', 'large'])
};

export default TextInput;



/** WEBPACK FOOTER **
 ** ./src/TextInput/index.js
 **/